var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.vista && _vm.vista.config.paso)?_c('div',{staticClass:"container",class:{ vertical: _vm.vertical }},[_c('arrow-left'),_c('div',{staticClass:"adelante"},[_c('sales-button',{staticClass:"button",attrs:{"label":_vm.nombreSiguiente,"disabled":_vm.disabled === true},on:{"click":_vm.adelante}})],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }